import ZInput from './input.vue'

ZInput.install = function(app) {
  app.component(ZInput.name, ZInput)
}

export default ZInput